import {makeStyles, TextField, Button} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import useRouter from 'packages/hooks/use-router';
import {ChangeEvent, useState} from 'react';
import {resetPassword} from 'services/firebase-service';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#ECFDF5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
  cardContainer: {
    backgroundColor: '#fff',
    minWidth: '400px',
    display: 'flex',
    padding: '20px',
    borderRadius: '20px',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
  },
  cardFooter: {
    display: 'flex',
    paddingTop: '20px',
    justifyContent: 'flex-end',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      margin: '0',
      fontSize: '24px',
    },
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [confirmationSent, setConfirmationSent] = useState(false);
  const {history} = useRouter();

  const handleGoBack = () => {
    history.goBack();
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError('Ingresa tu correo para continuar');
      return;
    }

    try {
      setLoading(true);
      await resetPassword(email);
      setConfirmationSent(true);
      setError('');
    } catch (error) {
      console.error(error);
      const firebaseError = (error as firebase.default.FirebaseError).code;
      if (firebaseError === 'auth/user-not-found') {
        setError('El usuario con este correo no ha sido encontrado');
      } else {
        setError('Something went wrong');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  return (
    <div className={classes.root}>
      <section className={classes.cardContainer}>
        {error && (
          <Alert id="error-alert" severity="error">
            {error}
          </Alert>
        )}
        <header className={classes.cardHeader}>
          <h1>{confirmationSent ? 'Enviado!' : 'Recuperar contraseña'}</h1>
          <p id="success-alert">
            {confirmationSent
              ? 'Hemos enviado un correo de recuperación, revisalo y sigue las instrucciones para el cambio de clave'
              : `Ingresa tu dirección de correo electrónico y te enviaremos un enlace
            para restablecer tu contraseña`}
          </p>
        </header>
        {!confirmationSent && (
          <form>
            <div className="form-group">
              <TextField
                id="email"
                label="Correo electrónico"
                type="email"
                variant="outlined"
                onChange={handleChange}
                fullWidth
                placeholder="Ingresa el correo electrónico con el que te registraste"
              />
            </div>
          </form>
        )}
        <footer className={classes.cardFooter}>
          <Button
            disableElevation
            onClick={handleGoBack}
            name="btn-back"
            style={{
              textTransform: 'none',
              fontWeight: 600,
              marginRight: '15px',
            }}
          >
            Volver
          </Button>
          {!confirmationSent && (
            <Button
              color="primary"
              variant="contained"
              disableElevation
              name="btn-reset"
              disabled={loading}
              onClick={handleResetPassword}
              style={{textTransform: 'none', fontWeight: 600}}
            >
              {loading ? 'Enviando...' : 'Enviar'}
            </Button>
          )}
        </footer>
      </section>
    </div>
  );
};

export default ForgotPassword;
